// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3V_tN","modalForm":"UpgradeEpcsModal_modalForm__LsUCc","modalFooter":"UpgradeEpcsModal_modalFooter__2GLgP"};